import { useLang } from "@/i18n";
import { cn } from "@/lib/utils";

const STYLES = {
  paid: "bg-emerald-100 dark:bg-emerald-950/60 text-emerald-800 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800",
  issued: "bg-sky-100 dark:bg-sky-950/60 text-sky-800 dark:text-sky-300 border-sky-300 dark:border-sky-800",
  draft: "bg-amber-100 dark:bg-amber-950/60 text-amber-800 dark:text-amber-300 border-amber-300 dark:border-amber-800",
  cancelled: "bg-rose-100 dark:bg-rose-950/60 text-rose-800 dark:text-rose-300 border-rose-300 dark:border-rose-800",
  overdue: "bg-red-100 dark:bg-red-950/60 text-red-800 dark:text-red-300 border-red-300 dark:border-red-800",
};
const DOTS = { paid: "bg-emerald-500", issued: "bg-sky-500", draft: "bg-amber-500", cancelled: "bg-rose-500", overdue: "bg-red-600 animate-pulse" };

export const isOverdue = (doc) =>
  doc.status === "issued" && ["invoice", "service_invoice", "retail_receipt"].includes(doc.type) && doc.due_date && doc.due_date < new Date().toISOString().slice(0, 10);

export const StatusBadge = ({ doc, status, className, ...props }) => {
  const { t } = useLang();
  const key = doc ? (isOverdue(doc) ? "overdue" : doc.status) : status;
  return (
    <span data-testid="document-status-badge" {...props}
      className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-xs font-semibold uppercase tracking-wider", STYLES[key], className)}>
      <span className={cn("w-1.5 h-1.5 rounded-full", DOTS[key])} />
      {t(`status_${key}`)}
    </span>
  );
};

const TYPE_STYLES = {
  invoice: "text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-950/40 border-blue-200 dark:border-blue-800",
  service_invoice: "text-indigo-700 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-950/40 border-indigo-200 dark:border-indigo-800",
  retail_receipt: "text-cyan-700 dark:text-cyan-300 bg-cyan-50 dark:bg-cyan-950/40 border-cyan-200 dark:border-cyan-800",
  purchase: "text-orange-700 dark:text-orange-300 bg-orange-50 dark:bg-orange-950/40 border-orange-200 dark:border-orange-800",
  purchase_service: "text-rose-700 dark:text-rose-300 bg-rose-50 dark:bg-rose-950/40 border-rose-200 dark:border-rose-800",
  expense: "text-amber-800 dark:text-amber-300 bg-amber-50 dark:bg-amber-950/40 border-amber-300 dark:border-amber-800",
};

export const TypeBadge = ({ type, className }) => {
  const { t } = useLang();
  return (
    <span className={cn("inline-flex px-2 py-0.5 rounded border text-xs font-medium", TYPE_STYLES[type], className)}>
      {t(`doc_${type}`)}
    </span>
  );
};

const CONTACT_STYLES = {
  customer: "text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-950/40 border-blue-200 dark:border-blue-800",
  supplier: "text-orange-700 dark:text-orange-300 bg-orange-50 dark:bg-orange-950/40 border-orange-200 dark:border-orange-800",
  both: "text-slate-700 dark:text-slate-300 bg-slate-100 dark:bg-slate-800 border-slate-300 dark:border-slate-700",
};

export const ContactTypeBadge = ({ type }) => {
  const { t } = useLang();
  return (
    <span className={cn("inline-flex px-2 py-0.5 rounded border text-xs font-medium", CONTACT_STYLES[type])}>{t(type)}</span>
  );
};
